export class EmailSetup {
    public ACC_CODE!: number;
    public IS_SMS: boolean = false;
    public IS_MAIL: boolean = false;
    public IS_BOOKINGREPORT: boolean = false;
    public IS_DELIVERYREPORT: boolean = false;
    public IS_MISREPORT: boolean = false;
    public IS_OUTSTANDINGREPORT: boolean = false;
    public OS_FREQUENCY!: string;
    public MAIL_HOUR!: number;
    public MIS_EMAIL!: string;
    public GR_EMAIL!: string;
    public OUTSTANDING_EMAIL!: string;
    public BILLING_EMAIL!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE: boolean = false;
}